<template>
  <div>
    <alert-message-modal></alert-message-modal>
    <Navigation active="packages"></Navigation>
    <div class="row">
      <div class="col-12 table-overlay">
        <div class="block">
          <div v-if="showLoader" class="overlay"></div>
          <hash-loader v-if="showLoader" class="hash-icon table-hash-icon" color="#D2695C" loading="loading" size="40" sizeUnit="px"></hash-loader>
          <div class="block-header bg-danger">
            <h3 class="block-title text-white"><i class="fa fa-box-open"></i> Packages</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option text-white" @click.prevent="showPackagesCreationModal()">
                <i v-bind:disabled="showLoader" class="si si-plus"></i> Create package
              </button>
            </div>
          </div>
          <div class="block-content block-content-full table-overview">
              <table id="packages-overview" class="table table-bordered table-striped table-vcenter js-dataTable-full js-table-checkable">
              <thead>
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center">Label</th>
                  <th class="text-center">Type</th>
                  <th class="text-center">Product Name</th>
                  <th class="text-center">Room Name</th>
                  <th class="text-center">Quantity</th>
                  <th class="text-center no-sorting">Advance</th>
                </tr>
              </thead>
              <tbody>{{ getPackageEntries }}
                <tr v-for="(pack, index) in packages" :key="index">
                  <td class="text-center font-size-sm">{{ pack.Id }}</td>
                  <td class="text-center font-size-sm">
                     <router-link :to="`/packages/details/${pack.Id}`">{{ pack.Label }}</router-link>
                  </td>
                  <td class="text-center font-size-sm">{{ pack.PackageType }}</td>
                  <td class="text-center text-break">{{ pack.ProductName }}</td>
                  <td class="text-center text-break">{{ pack.RoomName }}</td>
                  <td class="text-center">{{ pack.Quantity }} {{ pack.UnitOfMeasureName }}</td>
                  <td class="text-center button-loader">
                    <button class="btn btn-danger" title="Change Item" @click.prevent="showChangeItemModal(pack.Label)">
                      <i class="fa fa-exchange-alt text-white"></i>
                    </button>
                    <button class="btn btn-danger" title="Change Room" @click.prevent="showChangeRoomModal(pack.Label)">
                      <i class="fa fa-angle-double-right text-white"></i>
                    </button>
                    <button class="btn btn-danger" title="Adjust Quantity" @click.prevent="showAdjustQuantityModal(pack.Label)">
                      <i class="fa fa-balance-scale text-white"></i>
                    </button>
                    <button class="btn btn-danger" title="Remediate" @click.prevent="showRemediatePackageModal(pack.Label)">
                      <i class="fa fa-edit text-white"></i>
                    </button>                      
                    <button type="button" @click.prevent="finish(pack.Label, index)" :disabled="showButtonLoader" class="btn btn-sm btn-danger" title="Click to finish.">
                      <div><span>Finish</span></div>
                      <span class="modal-loader d-none" :id="`finish-button-${index}`">
                        <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
                      </span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    
    <!--Begin change-package-item modal-window-->
    <ChangeItem 
      ref="changeItem"
      @loadPackage="fetch"
      @showSuccessMsg="displaySuccessMsg"
    ></ChangeItem>
    <!--End change-package-item modal-window-->
    
    <!--Begin change-package-room modal-window-->
    <ChangeRoom
      ref="changeRoom"
      @loadPackage="fetch"
      @showSuccessMsg="displaySuccessMsg"
    ></ChangeRoom>
    <!--End change-package-room modal-window-->
    <!--Begin adjust-quantity modal-window-->
    <AdjustQuantity
      ref="adjustQuantity"
      @loadPackage="fetch"
      @showSuccessMsg="displaySuccessMsg" 
    ></AdjustQuantity>
    <!--End adjust-quantity modal-window-->
    <!--Begin remediate modal-window-->
    <RemediatePackage
      ref="remediate"
      @loadPackage="fetch"
      @showSuccessMsg="displaySuccessMsg" 
    ></RemediatePackage>
    <!--End remediate modal-window-->
    <!--Begin create-package-from-harvest modal-window-->
    <AddPackage
      @showSuccessMsg="displaySuccessMsg"
      @loadPackage="fetch"
    ></AddPackage>
    <!--End create-package-from-harvest modal-window-->
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import Navigation from '@/components/Navigation';
import AlertMessageModal from '@/components/AlertMessageModal';
import AddPackage from '@/components/modals/AddPackage';
import ChangeItem from '@/components/modals/ChangeItem';
import ChangeRoom from '@/components/modals/ChangeRoom';
import AdjustQuantity from '@/components/modals/AdjustQuantity';
import RemediatePackage from '@/components/modals/RemediatePackage';
import $ from 'jquery';
import * as select2 from 'select2/dist/js/select2.full.js';
import 'select2/dist/css/select2.min.css';

Vue.use(VueSpinners);

export default {
  name: 'PackageOverview',
  data() {
    return {
      packages: [],
      isTableEnabled: false,
      showLoader: false,
      showButtonLoader: false
    };
  },
  components: {
    Navigation,
    AlertMessageModal,
    HashLoader,
    AddPackage,
    ChangeItem,
    ChangeRoom,
    AdjustQuantity,
    RemediatePackage
  },
  created() {
    this.fetch(false);
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
    this.loadFile('/static/js/oneui.app.min.js', 'js');  
    this.loadFile('/static/js/be_tables_datatables.min.js', 'js');    
  },
  mounted() {
    $('.package-select2-dropdown').each(function(){
      $(this).select2({
        dropdownParent: $(this).parent(),
        placeholder: $(this).attr('placeholder')
      });
    });
  },
  computed: {
    ...mapState({
      library: state => state.library
    }),
    getPackageEntries() {
      if (this.$store.state.library.packages.length) {
        return this.enableDataTable(this.$store.state.library.packages);
      }
    }
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllPackages']),
    ...mapGetters('library', ['getPackages']),
    async fetch(force) {
      if (force || this.getPackages().length === 0) {
        this.showLoader = true;
        await this.getAllPackages();
      }
      if (this.getPackages().length === 0) {
        this.enableDataTable([]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#packages-overview').DataTable();
        table.destroy();
      }
      vm.packages = data;
      vm.prepareDataTable('#packages-overview');
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    showPackagesCreationModal() {
      jQuery('#create_package').modal('show');
    },
    showChangeItemModal(label) {
      this.$refs.changeItem.setData(label);
      jQuery('#change-package-item').modal('show');
    },
    showChangeRoomModal(label) {
      this.$refs.changeRoom.setData(label);
      jQuery('#change-package-room').modal('show');
    },
    showAdjustQuantityModal(label) {
      this.$refs.adjustQuantity.setData(label);
      jQuery('#adjust-quantity').modal('show');
    },
    showRemediatePackageModal(label) {
      this.$refs.remediate.setData(label);
      jQuery('#remediate').modal('show');
    },
    displaySuccessMsg(message) {
      this.success(message);
      this.triggerMessageModal('#alert_modal');
    },
    finish(label, id) {
      let vm = this;
      jQuery('#finish-button-' + id).removeClass('d-none');
      helper.sendPostRequest('/packages/finish', {
        'Label': label,
        'ActualDate': new Date().toJSON().slice(0,10)
      }).then((data) => {
        if (data.status === 'success') {
          helper.showSuccessModal(data.message);
          vm.fetch(false);
        } else {
          jQuery('#finish-button-' + id).addClass('d-none');
          helper.showErrorModal(data);
        }
      });
    }
  },
  beforeDestory() {
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
  }
};
</script>



// WEBPACK FOOTER //
// source/components/PackageOverview.vue